import React from 'react';
import { Typography, FormControlLabel, Checkbox } from '@mui/material';
import FlowAgreementsSection from './FlowAgreementsSection';

/**
 * Shared T&C + age gate for email and Google signup.
 */
const SignupAgreementsSection = ({
  regDocuments = [],
  checkedDocs = {},
  onCheckChange,
  is13OrOlder = false,
  onAgeChange,
  onViewDocument,
  docsLoading = false,
  docsError = false,
}) => (
  <FlowAgreementsSection
    documents={regDocuments}
    checkedDocs={checkedDocs}
    onCheckChange={onCheckChange}
    onViewDocument={onViewDocument}
    docsLoading={docsLoading}
    docsError={docsError}
    title="Required agreements (email & Google signup)"
  >
    <FormControlLabel
      control={
        <Checkbox
          checked={is13OrOlder}
          onChange={(e) => onAgeChange(e.target.checked)}
          color="primary"
        />
      }
      label={
        <Typography variant="body2">
          I confirm that I am 13 years old or older.
        </Typography>
      }
      sx={{ alignItems: 'flex-start', mt: 0.5, ml: 0 }}
    />
  </FlowAgreementsSection>
);

export default SignupAgreementsSection;
